import React, { useState, forwardRef } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { Modal, Dropdown } from 'react-bootstrap'

// Плашка оператора в шапке колл-центра — как в Mison (OperatorReportBlock), но без
// X-отчёта: у бэкенда KingPlov нет /report-operator. В меню только выход
const OperatorProfileToggle = forwardRef(function OperatorProfileToggle(
	{ children, onClick, className = '' },
	ref
) {
	return (
		<div
			ref={ref}
			className={className}
			onClick={(e) => {
				e.preventDefault()
				onClick(e)
			}}>
			{children}
		</div>
	)
})

export default function OperatorProfileBlock({ chipClassName = '', onLogout = null }) {
	const { t } = useTranslation()
	const reduxAccount = useSelector(state => state.account)
	const [modalLogout, setModalLogout] = useState(false)

	return (
		<>
			<Dropdown align="end">
				<Dropdown.Toggle
					as={OperatorProfileToggle}
					className={`operator-profile-chip ${chipClassName}`.trim()}>
					<div className="operator-profile-avatar">
						{(reduxAccount.first_name || reduxAccount.login || '?').charAt(0).toUpperCase()}
					</div>
					<div className="operator-profile-text">
						<span className="operator-profile-login">{reduxAccount.login}</span>
						<span className="operator-profile-name">{reduxAccount.first_name}</span>
					</div>
				</Dropdown.Toggle>

				<Dropdown.Menu className="operator-profile-menu">
					{typeof onLogout === 'function' &&
						<Dropdown.Item className="text-danger" onClick={() => setModalLogout(true)}>
							<i className="uil uil-sign-out-alt me-2"></i>
							{t('logout')}
						</Dropdown.Item>
					}
				</Dropdown.Menu>
			</Dropdown>

			<Modal show={modalLogout} animation={false}
				centered dialogClassName="update-modal-width"
				onHide={() => setModalLogout(false)}>
				<Modal.Header closeButton>
					<Modal.Title>{t('logout')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					{t('are_you_sure_you_want_logout')}
				</Modal.Body>
				<Modal.Footer>
					<div className="d-flex gap-2 w-100">
						<button className="btn btn-warning w-100"
							onClick={() => setModalLogout(false)}>
							{t('cancel')}
						</button>
						<button className="btn btn-primary w-100"
							onClick={() => {
								setModalLogout(false)
								onLogout()
							}}>
							{t('confirm')}
						</button>
					</div>
				</Modal.Footer>
			</Modal>
		</>
	)
}
